function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.0122 2.08894C14.5911 0.0106205 16.7861 0.000488281 16.7861 0.000488281C16.7861 0.000488281 17.1126 1.95446 15.5441 3.83677C13.8692 5.84665 11.9656 5.51777 11.9656 5.51777C11.9656 5.51777 11.6081 3.93706 13.0122 2.08894ZM12.1664 6.88652C12.9786 6.88652 14.4862 5.77143 16.4484 5.77143C19.8261 5.77143 21.1549 8.17173 21.1549 8.17173C21.1549 8.17173 18.556 9.49873 18.556 12.7186C18.556 16.351 21.7935 17.6028 21.7935 17.6028C21.7935 17.6028 19.5304 23.9643 16.4736 23.9643C15.0696 23.9643 13.9781 23.0194 12.4988 23.0194C10.9912 23.0194 9.49525 23.9995 8.52089 23.9995C5.72955 23.9996 2.20312 17.9651 2.20312 13.1143C2.20312 8.34185 5.18801 5.83829 7.98772 5.83829C9.80778 5.83829 11.2202 6.88652 12.1664 6.88652Z",
  fill: "#181827"
});

function SvgAppleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple-icon.da069c38.svg";
export { ForwardRef as ReactComponent };